module.exports = __webpack_public_path__ + "static/media/1.839974c3.jpg";